module.exports = __webpack_public_path__ + "media/images/bluesky_logo-dd7af53e.svg";